import request from '@/utils/request'

const service = (config) => {
  return request(config)
}

export default service
